import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AppointmentDate, AvailableHour, TimeGrouping, AvailableTime } from 'src/app/api/models/web-booking.models';
import { AppConstants } from 'src/app/app.constants';
import { BaseComponent } from 'src/app/layout/main/base.component';

@Component({
  selector: 'app-reschedule',
  templateUrl: './reschedule.component.html',
  styleUrls: ['./reschedule.component.scss']
})
export class RescheduleComponent extends BaseComponent implements OnInit, AfterViewInit {

  public calendarViewCount: number = 0;

  public availableSlots: AppointmentDate[] = [];
  public selectedSlot: AppointmentDate | null = null;
  public selectedHour: AvailableHour | null = null;
  public selectedHourGroup: TimeGrouping | null = null;
  public preferredDateAndTime: AvailableTime | null = null;

  public selectedDate: Date | null = new Date();
  public oldStartDate: Date = new Date();
  public oldEndDate: Date = new Date();

  public focusedDate: Date = new Date();
  public startDate: Date = new Date();
  public endDate: Date = new Date();
  public minDate: Date = new Date();

  public activeRangeEnd: any;
  public tdx!: NodeListOf<Element>;
  public previousButton: any;
  public nextButton: any;

  public maxGuestCount = 1;

  public isConfirmButtonIsDisabled = true;
  public isPassSeven = false;

  public appointment: any;

  ngOnInit(): void {
    this.baseTriggerChild.subscribe(event => {
      this.initialize();
    });
  }
  ngAfterViewInit(): void {
    this.start();
  }
  
  initialize(): void {
    const aid = this.app.getParameterByName('aid', location.href);
    if (this.app.stringService.isNotEmpty(aid)) {
      this.retrieveAppointmentByAppointmentId(aid);
    } else {
      this.app.router.navigate(['invalid-link']);
    }
  }

  
  retrieveAppointmentByAppointmentId(appointmentId: string) {
    const model = {
      appointmentId: appointmentId
    };
    this.app.spinner.show();
    this.app.webBookingService.RetrieveAppointmentByAppointmentId(model)
      .subscribe(
        (data) => {
          this.app.spinner.hide();
          this.appointment = data;
          this.checkAvailableSlot();
        },
        (error) => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  checkAvailableSlot(): void {
    this.app.spinner.show();

    this.minDate = new Date(this.minDate.getFullYear(), this.minDate.getMonth(), this.minDate.getDate(), 0, 0, 0);
    this.calendarViewCount = 1;
    this.maxGuestCount = 1;

    setTimeout((e) => {
      this.previousButton = document.getElementsByClassName('k-prev-view')[0];
      this.previousButton.addEventListener('click', () => {
        const startDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate());
        startDate.setDate(this.startDate.getDate() - (this.app.configService.config.bookingAvailableDaysChecking));
        setTimeout((n) => {
          this.selectedSlot = null;
          this.selectedHour = null;
          this.selectedHourGroup = null;
          this.availableSlots = [];
          this.getStartAndEndDate(false, startDate);
        }, 100);
      });

      this.nextButton = document.getElementsByClassName('k-next-view')[0];
      this.nextButton.addEventListener('click', () => {
        const startDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate());
        startDate.setDate(startDate.getDate() + 1);
        this.selectedDate = startDate;
        setTimeout((n) => {
          this.selectedSlot = null;
          this.selectedHour = null;
          this.selectedHourGroup = null;
          this.availableSlots = [];
          this.getStartAndEndDate(false, startDate);
        }, 100);
      });

      const calHeader = document.getElementsByClassName('k-calendar-header')[0];
      const btnToday = calHeader.querySelectorAll('.k-today');
      btnToday[0].addEventListener('click', () => {
        setTimeout(() => {
          this.selectedSlot = null;
          this.selectedHour = null;
          this.selectedHourGroup = null;
          this.getStartAndEndDate(true);
        }, 100);
      });

    }, 100);

    const tmpSlotDate = this.app.storageService.getItem(AppConstants.BookingSelectedDate);
    let slotDate: any = null;
    if (this.app.stringService.isNotEmpty(tmpSlotDate)) {
      slotDate = JSON.parse(tmpSlotDate);
      const date = this.app.dateService.getNewDate(slotDate.appointmentDate);
      if (date > this.minDate) {
        this.selectedDate = date;
      }
    }

    setTimeout((n) => {
      let startDate: Date = null;
      if (slotDate != null) {
        const table = document.getElementsByClassName('k-content')[0];
        this.tdx = table.querySelectorAll('tr > [data-cell-index]');
        const lastTd = this.tdx[this.tdx.length - 1];
        const date = new Date(Date.parse(lastTd.getAttribute('title').toString()));
        let startDay = 1;
        if (this.selectedDate.getMonth() < date.getMonth()) {
          if (this.selectedDate.getDate() > 15) { startDay = 10; }
        }
        startDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), startDay);
      }
      if (startDate < this.minDate) { startDate = this.minDate; }
      this.availableSlots = [];
      this.getStartAndEndDate(false, startDate, true);
    }, 100);
  }

  back(): void {    
    history.back();
  }

  next(): void { 
    const model = {
      appointmentId: this.appointment.appointmentId,
      slot: this.preferredDateAndTime.slots[0]
    };
    this.app.spinner.show();
    this.app.webBookingService.Reschedule(model)
      .subscribe(
        (data) => {
          this.app.spinner.hide();
          this.showSuccessMessage('Appointment successfully reschedule.');
          history.back();
        },
        (error) => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  onPreferredDateClick(availableDateTimeAndSlot: AvailableTime): void {
    this.preferredDateAndTime = availableDateTimeAndSlot;
    this.isConfirmButtonIsDisabled = false;

    // Pass Seven Functionality
    const selectedDate = this.app.dateService.getNewDate(this.preferredDateAndTime.time);
    this.isPassSeven = selectedDate.getHours() >= 19;
  }

  onPreferredHourGroupClick(hour: TimeGrouping): void {
    this.selectedHourGroup = hour;
  }


  onCellEnter(value: Date): void {
  }

  onCellLeave(value: Date): void {
  }

  onChange(value: Date): void {
  }

  onActiveViewChange(value: string): void {
    if (value.toLowerCase() !== 'month') {
      return;
    }
    setTimeout(() => {
      this.selectedSlot = null;
      this.getStartAndEndDate(true);
    }, 30);
  }

  getStartAndEndDate(setTodayDate: boolean = false, newStartDate: Date | null = null, isFromInit: boolean = false): void {
    const table = document.getElementsByClassName('k-content')[0];
    this.tdx = table.querySelectorAll('tr > [data-cell-index]');

    Array.prototype.forEach.call(this.tdx, (e: Element) => {
      e.removeEventListener('onclick', () => { }, false);
      e.addEventListener('click', (event: any) => {
        if (this.availableSlots === null || this.availableSlots.length === 0) {
          return;
        }
        const nDate = new Date(Date.parse(
          this.app.stringService.isNotEmpty(event.target.title) ? event.target.title : event.target.parentNode.title));
        if (this.isDateBlocked(nDate)) {
          return;
        }
        for (const f of this.availableSlots) {
          if ((this.app.dateService.formatDate(nDate) === this.app.dateService.formatDate(this.app.dateService.getNewDate(f.appointmentDate)))) {
            if (f.availableTimes.length > 0) {
              this.getAvailableSlotPerDay(f.appointmentDate);
            }
          }
        }
      });
    });

    const firstTd = this.tdx[0];
    if (this.app.stringService.isNotEmpty(firstTd.getAttribute('title'))) {
      const date = Date.parse(firstTd.getAttribute('title').toString());
      if (this.app.stringService.isNotEmpty(date)) {
        this.startDate = new Date(date);
      }
    }
    if (this.startDate < this.minDate) {
      this.startDate = this.minDate;
    }
    if (this.startDate <= this.minDate) { }

    // Get last date of the calendar
    const lastTd = this.tdx[this.tdx.length - 1];
    if (this.app.stringService.isNotEmpty(lastTd.getAttribute('title'))) {
      const date = Date.parse(lastTd.getAttribute('title').toString());
      if (this.app.stringService.isNotEmpty(date)) {
        this.endDate = new Date(date);
      }
      if (this.endDate < this.minDate) {
        this.endDate = this.minDate;
      }
    }

    // 30 Days
    if (this.app.configService.config.enable30Days) {
      if (newStartDate != null) {
        this.startDate = newStartDate;
      }
      const lastDay = new Date(this.startDate.getFullYear(), this.startDate.getMonth() + 1, 0).getDate();
      const minusCheck = lastDay === 31 ? 0 : 1;
      this.endDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate());
      this.endDate.setDate(this.endDate.getDate() + (this.app.configService.config.bookingAvailableDaysChecking - minusCheck));
    }

    this.focusedDate = this.startDate;

    let retrieveNewAvailability = false;
    if (this.availableSlots != null && this.availableSlots.length > 0) {
      const x = this.app.dateService.getNewDate(this.availableSlots[0].appointmentDate);
      const y = this.app.dateService.getNewDate(this.availableSlots[this.availableSlots.length - 1].appointmentDate);
      if (this.app.dateService.formatDate(this.startDate) === this.app.dateService.formatDate(x) &&
          this.app.dateService.formatDate(this.endDate) === this.app.dateService.formatDate(y)) {
        if (this.availableSlots === null || this.availableSlots.length === 0) {
          return;
        }
        for (const f of this.availableSlots) {
          if ((this.app.dateService.formatDate(this.minDate) === this.app.dateService.formatDate(this.app.dateService.getNewDate(f.appointmentDate)))) {
            if (f.availableTimes.length > 0) {
              this.getAvailableSlotPerDay(f.appointmentDate);
            }
          }
        }
      } else {
        retrieveNewAvailability = true;
      }
    } else {
      retrieveNewAvailability = true;
    }

    if (retrieveNewAvailability) {
      this.getAvailableSlot(setTodayDate, isFromInit);
    }
    this.selectedDate = null;
  }

  getAvailableSlot(setTodayDate: boolean = false, isFromInit = false): void {

    const maxGuestCount = 1;
    const m = {
      appointmentId: this.appointment.appointmentId,
      branchId: this.appointment.branchId,
      startDate: this.app.dateService.formatDateTime(this.startDate),
      endDate: this.app.dateService.formatDateTime(this.endDate),
      guestCount: maxGuestCount,
    };
    this.app.spinner.show();
    this.app.loadingDescription = 'Checking available dates...';
    this.app.webBookingService.GetAvailableSlotsByAppointmentId(m)
      .subscribe(
        (data: AppointmentDate[]) => {
          this.app.spinner.hide();
          this.availableSlots = data;

          const currentDateTime = new Date();
          const currentDate = new Date(currentDateTime.getFullYear(), currentDateTime.getMonth(), currentDateTime.getDate());

          Array.prototype.forEach.call(this.tdx, (e: Element) => {
            // Get Date
            const date = new Date(Date.parse(e.getAttribute('title').toString()));
            let className = 'disabled ';

            if (date < currentDate) {
              className = 'past-date ';
            }

            if (this.availableSlots === null || this.availableSlots.length === 0) {
              e.className = className + 'no-roster';
              if ((className === 'disabled ' || className === 'past-date ') && e.removeEventListener) {
                e.removeEventListener('click', () => { }, false);
              }
              return;
            }

            for (const a of this.availableSlots) {
              // Auto Set Today Date
              let slotDate: AppointmentDate;
              let slotTime: AvailableTime;
              if(this.app.stringService.isNotEmpty(this.app.storageService.getItem(AppConstants.BookingSelectedDate))
              && this.app.stringService.isNotEmpty(this.app.storageService.getItem(AppConstants.BookingSelectedTime)))
              {
                slotDate = JSON.parse(this.app.storageService.getItem(AppConstants.BookingSelectedDate)) as AppointmentDate;
                slotTime = JSON.parse(this.app.storageService.getItem(AppConstants.BookingSelectedTime)) as AvailableTime;
              }

              if (isFromInit &&
                slotDate != null &&
                slotTime != null &&
                this.app.dateService.formatDate(this.app.dateService.getNewDate(slotTime.time)) === this.app.dateService.formatDate(this.app.dateService.getNewDate(a.appointmentDate)) &&
                this.app.dateService.formatDate(this.app.dateService.getNewDate(slotTime.time)) === this.app.dateService.formatDate(date) &&
                !this.isDateBlocked(date)) {

                this.focusedDate = this.app.dateService.getNewDate(slotTime.time);
                this.getAvailableSlotPerDay(slotTime.time, slotDate);
                className = 'meeting k-state-selected';
              } else if (setTodayDate &&
                this.app.dateService.formatDate(date) === this.app.dateService.formatDate(this.app.dateService.getNewDate(a.appointmentDate)) &&
                this.app.dateService.formatDate(date) === this.app.dateService.formatDate(this.minDate) &&
                !this.isDateBlocked(date)) {
                this.selectedSlot = a;
                className = 'meeting k-state-selected';
              } else if (
                this.app.dateService.formatDate(date) === this.app.dateService.formatDate(this.app.dateService.getNewDate(a.appointmentDate)) &&
                a.availableTimes.length > 0 &&
                !this.isDateBlocked(date)) {
                className = 'meeting';
              } else if (
                this.app.dateService.formatDate(date) === this.app.dateService.formatDate(this.app.dateService.getNewDate(a.appointmentDate)) &&
                (a.availableTimes.length === 0 ||
                  this.isDateBlocked(date))) {
                className = 'no-schedule';
              }
            }
            e.className = className;
          });

        },
        (error: any) => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  isDateBlocked(date: Date): boolean {
    // const isPromo = this.selectedTreatment.isPromo;
    // if (this.app.config.disableWeekDays != null && this.app.config.disableWeekDays.length > 0) {
    //   for (const weekDay of this.app.config.disableWeekDays) {
    //     if (weekDay === date.getDay() && isPromo) {
    //       return true;
    //     }
    //   }
    // }
    return false;
  }

  getAvailableSlotPerDay(selectedDate: string, slotDate: any = null): void {
    this.isConfirmButtonIsDisabled = true;
    const maxGuestCount = 1;

    const m = {
      appointmentId: this.appointment.appointmentId,
      branchId: this.appointment.branchId,
      preferredDate: selectedDate,
      guestCount: maxGuestCount,
    };
    this.app.spinner.show();
    this.app.loadingDescription = 'Checking available time...';
    this.app.webBookingService.GetAvailableSlotPerDayByAppointmentId(m)
      .subscribe(
        (data: string | any[] | null) => {
          this.app.spinner.hide();
          if (data != null && data.length > 0) {
            this.preferredDateAndTime = null;
            this.selectedSlot = data[0];
            this.selectedHourGroup = this.selectedSlot.timeGroupings[0];
            //const slotTime = JSON.parse() as AvailableTime;
            const strSlotTime = this.app.storageService.getItem(AppConstants.BookingSelectedTime);
            if (
              this.selectedSlot != null &&
              slotDate != null &&
              this.app.stringService.isNotEmpty(strSlotTime) &&
              this.selectedSlot.availableTimes != null) {
              const slotTime = JSON.parse(strSlotTime);
              for (const f of this.selectedSlot.availableTimes) {
                if (f.time === slotTime.time) {
                  this.preferredDateAndTime = f;
                }
              }
            } else {
              this.preferredDateAndTime = null;
            }
          } else {
            this.selectedSlot = null;
          }
        },
        (error: any) => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });


  }

  

  onBlur(): void {
  }

  onFocus(): void {
  }

}
